module.exports = __webpack_public_path__ + "media/images/blue_star-a852ef7e9b679c63db5c080cbe4fddda.svg";